import styled from "styled-components";
export const Styles = styled.div`
.main-data{
    min-height: 86vh;
    position: relative;
    padding-bottom: 10vh;
}
.main-data footer{
    position: absolute;
    left: 0;
    bottom:0;
    width: 100%;
}
`;